import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { pathOr } from 'ramda';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from 'react-spinner';

import { loadSubscriptions } from '../../redux/modules/order-history';
import { loadWellnessQuestionnaires } from '../../redux/modules/wellness/effects';

import { setBackgroundColor } from '../../helpers/documentHelpers';

import logo from '../../images/svg/icon-logo-symbol.svg';
import Earim from '../../images/med-Earim-bust.png';
import EarimLg from '../../images/med-Earim-bust@2x.png';


import './WellnessInstructionsPage.scss';

const prependZeros = (n, maxLength = `0${n}`.length) => `0${n}`.slice(-maxLength);

const WellnessInstructionsPage = ({
  instructions, linkUrl, fetchSubscriptions, waitForCart, isPOMLoading, loadWellnessQuestionnaires
}) => {
  useEffect(() => {
    setBackgroundColor('#F8F7F6');
    fetchSubscriptions(); // we preload the subscriptions here so the Goals screen loads faster
    loadWellnessQuestionnaires();
    return () => {
      setBackgroundColor(null);
    };
  }, []);

  return (
    <div className="WellnessInstructionsPage">
      <div className="WellnessInstructionsPage--container">
        <div className="SimpleHeader">
          <img src={logo} alt="" className="HeaderLogo" />
        </div>

        <div className="ttl">How it works</div>

        <div className="Doc">
          <img src={Earim} srcSet={`${EarimLg} 2x`} alt="" className="DocImg" />
          <div className="DocTtl">Earim Chaudry, Medical Director</div>
        </div>

        <div className="InstructionList">
          {
            instructions.map((str, i) => (
              <div className="InstructionTile" key={str}>
                <div className="no">{prependZeros(i + 1, 2)}</div>
                <div className="txt">{str}</div>
              </div>
            ))
          }
        </div>
        {
          waitForCart && isPOMLoading
            ? <button disabled className="btn btn--full btn--primary">&nbsp;<Spinner /></button>
            : <Link to={linkUrl} className="btn btn--full btn--primary">CONTINUE</Link>
        }
      </div>
    </div >

  );
};

WellnessInstructionsPage.propTypes = {
  instructions: PropTypes.arrayOf(PropTypes.string),
  linkUrl: PropTypes.string,
  fetchSubscriptions: PropTypes.func,
  waitForCart: PropTypes.bool,
  isPOMLoading: PropTypes.bool.isRequired,
  loadWellnessQuestionnaires: PropTypes.func,
};

WellnessInstructionsPage.defaultProps = {
  instructions: [
    'Select your goals and answer some simple health questions (2-3 mins)',
    'View the blood test and treatments recommended for you',
    'Choose your health plan and chat to one of our clinicians if you have any questions',
  ],
  linkUrl: '/wellness/quiz/0',
  fetchSubscriptions: () => {},
  loadWellnessQuestionnaires: () => {},
  waitForCart: false,
};

const mapStateToProps = state => {
  const isItemLoading = pathOr([], ['cart', 'isItemLoading'], state);
  const cartItems = pathOr([], ['cart', 'items'], state);
  const areItemsLoading = isItemLoading && Object.values(isItemLoading).length
    && !!Object.values(isItemLoading).find(i => i);
  const hasFakeItems = !!cartItems.find(i => i.isFakeItem);
  return {
    isPOMLoading: areItemsLoading || hasFakeItems,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchSubscriptions: async () => dispatch(loadSubscriptions()),
  loadWellnessQuestionnaires: async () => dispatch(loadWellnessQuestionnaires())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WellnessInstructionsPage);
